"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAssetTypes = exports.DefaultAssetTypeKeys = exports.AssetType = void 0;
class AssetType {
    constructor(key, title) {
        this.key = key;
        this.title = title;
    }
}
exports.AssetType = AssetType;
exports.default = AssetType;
// eslint-disable-next-line no-shadow
var DefaultAssetTypeKeys;
(function (DefaultAssetTypeKeys) {
    DefaultAssetTypeKeys["UNSPECIFIED"] = "unspecified";
    DefaultAssetTypeKeys["PROPERTIES"] = "properties";
    DefaultAssetTypeKeys["EQUIPMENT"] = "equipment";
    DefaultAssetTypeKeys["ITHARDWARE"] = "ithardware";
    DefaultAssetTypeKeys["SOFTWARE"] = "software";
    DefaultAssetTypeKeys["INFRASTRUCTURE"] = "infrastructure";
    DefaultAssetTypeKeys["FLEET"] = "fleet";
})(DefaultAssetTypeKeys = exports.DefaultAssetTypeKeys || (exports.DefaultAssetTypeKeys = {}));
exports.DefaultAssetTypes = [
    new AssetType(DefaultAssetTypeKeys.UNSPECIFIED, 'Unspecified'),
    new AssetType(DefaultAssetTypeKeys.PROPERTIES, 'Properties & Facilities'),
    new AssetType(DefaultAssetTypeKeys.EQUIPMENT, 'Equipment'),
    new AssetType(DefaultAssetTypeKeys.ITHARDWARE, 'IT Hardware'),
    new AssetType(DefaultAssetTypeKeys.SOFTWARE, 'Software & Apps'),
    new AssetType(DefaultAssetTypeKeys.INFRASTRUCTURE, 'Infrastructure'),
    new AssetType(DefaultAssetTypeKeys.FLEET, 'Fleet'),
];
